/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DimensionTypeResponse
 */
export interface DimensionTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof DimensionTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionTypeResponse
     */
    unitId?: number;
    /**
     * 
     * @type {string}
     * @memberof DimensionTypeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DimensionTypeResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the DimensionTypeResponse interface.
 */
export function instanceOfDimensionTypeResponse(value: object): value is DimensionTypeResponse {
    return true;
}

export function DimensionTypeResponseFromJSON(json: any): DimensionTypeResponse {
    return DimensionTypeResponseFromJSONTyped(json, false);
}

export function DimensionTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DimensionTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'unitId': json['unitId'] == null ? undefined : json['unitId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function DimensionTypeResponseToJSON(json: any): DimensionTypeResponse {
    return DimensionTypeResponseToJSONTyped(json, false);
}

export function DimensionTypeResponseToJSONTyped(value?: DimensionTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'unitId': value['unitId'],
        'name': value['name'],
        'description': value['description'],
    };
}

